import React, { useEffect, useState } from 'react';
import Footer from '../Components/Footer/Footer';
import Login from '../Components/Login/Login';
import LoginMenu from '../Components/Navbar/LoginNavbar';
import { Helmet } from 'react-helmet';
import * as queryString from "query-string";
import NoSSR from '../Components/CommonComponents/NoSSR';

export default function LoginPage(props) {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    const url_params = queryString.parse(props.location.search);

    const proxyToken = url_params?.token;
    const proxyDocTypeId = url_params?.doc_type_id;
    const proxyOrderId = url_params?.order_id;

    const isProxy = proxyToken || proxyDocTypeId || proxyOrderId;

    return (
        <div>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{isProxy ? 'Prodocs | Please Wait...' : 'Prodocs | Login'}</title>
                <link rel="canonical" href="/prodocs-logo.png" />
            </Helmet>

            {mounted && !isProxy && <LoginMenu />}
            <NoSSR>
            <Login url_params={url_params} />
            </NoSSR>
            {mounted && !isProxy && <Footer />}
        </div>
    );
}
